var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuspension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 25H27V38H29.75V25ZM38 25H35.25V38H38V25Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 32C52 35.9556 50.827 39.8224 48.6294 43.1114C46.4318 46.4004 43.3082 48.9638 39.6537 50.4776C35.9991 51.9913 31.9778 52.3874 28.0982 51.6157C24.2186 50.844 20.6549 48.9392 17.8579 46.1421C15.0608 43.3451 13.156 39.7814 12.3843 35.9018C11.6126 32.0222 12.0087 28.0009 13.5224 24.3463C15.0362 20.6918 17.5996 17.5682 20.8886 15.3706C24.1776 13.173 28.0444 12 32 12",
    stroke: "#737373",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.287 12.3455C45.1867 10.9064 45.6366 10.1868 46.2126 9.94004C46.7156 9.72451 47.285 9.72451 47.788 9.94004C48.3639 10.1868 48.8138 10.9064 49.7136 12.3455L53.9389 19.1036C54.938 20.7016 55.4376 21.5006 55.3847 22.16C55.3385 22.7348 55.0466 23.2617 54.5837 23.6055C54.0526 24 53.1103 24 51.2256 24H42.775C40.8903 24 39.9479 24 39.4169 23.6055C38.954 23.2617 38.662 22.7348 38.6159 22.16C38.5629 21.5006 39.0625 20.7016 40.0617 19.1036L44.287 12.3455Z",
    fill: "#FFAA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 13.8625C48 13.3482 47.6 13.0054 47 13.0054C46.4 13.0054 46 13.3482 46 13.8625V18.1482C46 18.6625 46.4 19.0054 47 19.0054C47.6 19.0054 48 18.6625 48 18.1482V13.8625ZM47 20.0054C46.448 20.0054 46 20.4534 46 21.0054C46 21.5574 46.448 22.0054 47 22.0054C47.552 22.0054 48 21.5574 48 21.0054C48 20.4534 47.552 20.0054 47 20.0054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspension);
export default __webpack_public_path__ + "static/media/suspension.1efa414d9d54b0105439a6d1c4d1b8d1.svg";
export { ForwardRef as ReactComponent };